import { useEffect, useRef, useState } from "react"
import styles from "../index.module.scss"
import { MdKeyboardDoubleArrowRight } from "react-icons/md"

const SwitchTo = () => {
  const [openDropdown, setOpenDropdown] = useState(false)
  const dropdownRef = useRef(null);

  const toggle = () => setOpenDropdown(!openDropdown)

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropdown(false);
    }
  };

  useEffect(() => {
    if (openDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div className={`${styles["switch-to"]} rounded cursor-pointer`} onClick={toggle}>
        Switch to <MdKeyboardDoubleArrowRight size={24} />
      </div>

      {openDropdown && (
        <div className={styles["dropdownMenu"]}>
          <ul className="mb-0">
            <li>Seller</li>
            <li>Affiliate</li>
            <li>Wholesaler</li>
            <li>Retailer</li>
            <li>Super Admin</li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default SwitchTo
